<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'App',

}
</script>

<style>
.sticky-action {
    position: sticky;
    right: 0;
    background-color: #fff;
    /* Màu nền để cột cố định không bị che khuất */
    z-index: 2;
    /* Đảm bảo cột cố định ở trên cùng */
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
    /* Tạo hiệu ứng bóng cho cột cố định */
}
.modal-header{
  padding: 0.5rem !important;
}
.form-group{
  margin-bottom:0.5rem !important;
}

.form-group label{
  margin-bottom: 0.2rem !important;
}

.cursor {
  cursor: pointer;
}
.error-import-cell {
    background-color: #df132e;
}

.col5 {
  width: 5px !important;
}

.col10 {
  width: 10px !important;
}

.col20 {
  width: 20px !important;
}

.col30 {
  width: 30px !important;
}

.col40 {
  width: 40px !important;
}

.col50 {
  width: 50px !important;
}

.col80 {
  width: 80px !important;
}

.col100 {
  width: 100px !important;
}

.col150 {
  width: 150px !important;
}

.col200 {
  width: 200px !important;
}

.col250 {
  width: 250px !important;
}

.col500 {
  width: 500px !important;
}

.cursor {
  cursor: pointer;
}

.modal-65vw {
    max-width: 65vw !important;
}

.modal-80vw {
    max-width: 80vw !important;
}
.modal-75vw {
    max-width:  75vw !important;
}

</style>
